import {IWithSummaryModel} from "../../../../common/permission/api/entity/iWithSummary.model";
import {InsolesProfileSummaryModel} from "./insolesProfileSummary.model";
import {LovValueSummary} from "../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {ProviderServiceCoveringModel} from "../../../../provider/service/api/entity/providerServiceCovering.model";
import {InsoleDataModel} from "../../../insoles/api/model/data/insoleData.model";

export class InsolesProfileModel implements IWithSummaryModel<InsolesProfileSummaryModel>{
    summary: InsolesProfileSummaryModel;
    color: LovValueSummary;
    providerCovering: ProviderServiceCoveringModel;
    leftInsoleData: InsoleDataModel;
    rightInsoleData: InsoleDataModel;
    symmetry: LovValueSummary;
    symmetrySubType: LovValueSummary;
}